// @flow

import React from "react";

import { FieldValue } from "./Values/styles";
import NameOrEmail from "src/containers/user/NameOrEmail";

import type { UID } from "src/types";

type Props = {
  newValue: ?UID,
};

const User = ({ newValue }: Props) => (
  <>
    {newValue && (
      <FieldValue>
        {newValue ? (
          <NameOrEmail uid={newValue} notificationVariant="key" />
        ) : null}
      </FieldValue>
    )}
  </>
);

export default User;
